import { render, staticRenderFns } from "./SingleDocument.vue?vue&type=template&id=b0b805fc&scoped=true&"
import script from "./SingleDocument.vue?vue&type=script&lang=js&"
export * from "./SingleDocument.vue?vue&type=script&lang=js&"
import style0 from "./SingleDocument.vue?vue&type=style&index=0&id=b0b805fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0b805fc",
  null
  
)

export default component.exports